<template>
  <div :class="$style['lv-docx-viewer__wrap']">
    <div v-if="isRendered" :class="$style['lv-docx-viewer__zoom-controls']">
      <button
        type="button"
        :class="$style['lv-docx-viewer__zoom-btn']"
        :disabled="scale <= scaleMin"
        @click="$_zoomOut"
      >
        <i class="icon-reduce" />
      </button>
      <button
        type="button"
        :class="$style['lv-docx-viewer__zoom-btn']"
        :disabled="scale >= scaleMax"
        @click="$_zoomIn"
      >
        <i class="icon-add" />
      </button>
    </div>
    <div :class="$style['lv-docx-viewer']">
      <div v-if="renderFailed" :class="$style['lv-docx-viewer__no-preview']">
        <LvText h3 bold>{{ $t('此檔案無法預覽') }}</LvText>
        <a download :class="$style['lv-docx-viewer__download-link']">
          <WsButton001 leading-icon="icon-cloud-download" @click="$_onDownload">
            {{ $t('下載檔案') }}
          </WsButton001>
        </a>
      </div>
      <div
        v-else
        :class="[$style['lv-docx-viewer__body'], { [$style['is-rendered']]: isRendered }]"
      >
        <div
          v-show="isRendered"
          ref="docxZoomWrap"
          :class="$style['lv-docx-viewer__zoom-wrap']"
          :style="docxZoomStyle"
        >
          <div ref="docxBody" :class="$style['lv-docx-viewer__docx']" />
          <div ref="docxStyle" :class="$style['lv-docx-viewer__style-container']" />
        </div>
        <LvLoading v-if="!isRendered" />
      </div>
    </div>
  </div>
</template>

<script>
import { renderAsync } from 'docx-preview/dist/docx-preview.js';

export default {
  props: {
    url: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isRendered: false,
      renderFailed: false,
      scale: 1,
      scaleMin: 0.5,
      scaleMax: 3,
      options: {
        breakPages: true,
      },
    };
  },
  watch: {
    url() {
      this.$_loadDocx();
    },
  },
  mounted() {
    this.$_loadDocx();
  },
  computed: {
    docxZoomStyle() {
      return {
        transform: `scale(${this.scale})`,
        transformOrigin: '0 0',
      };
    },
  },
  methods: {
    async $_loadDocx() {
      if (!this.url) return;
      this.isRendered = false;
      this.renderFailed = false;
      const bodyEl = this.$refs.docxBody;
      const styleEl = this.$refs.docxStyle;
      if (!bodyEl) return;
      try {
        const res = await fetch(this.url);
        if (!res.ok) throw new Error(res.statusText);
        const blob = await res.blob();
        bodyEl.innerHTML = '';
        if (styleEl) styleEl.innerHTML = '';
        await renderAsync(blob, bodyEl, styleEl || null, this.options);
        this.isRendered = true;
      } catch (e) {
        console.error('docx render failed', e);
        this.renderFailed = true;
      }
    },
    $_zoomIn() {
      if (this.scale >= this.scaleMax) return;
      this.scale = Math.min(this.scale + 0.25, this.scaleMax);
    },
    $_zoomOut() {
      if (this.scale <= this.scaleMin) return;
      this.scale = Math.max(this.scale - 0.25, this.scaleMin);
    },
    $_onDownload() {
      this.$emit('download', this.url);
    },
  },
};
</script>

<style lang="scss" module src="@/__common/scss/lv-docx-viewer.scss">
</style>
